import { useEffect, useState } from 'react';
import { FieldArray, useField } from 'formik';
import { useQuery } from '@tanstack/react-query';

import {
  DemographicFormData,
  getEmptyAudience,
} from '../../../../util/demographics';
import { audienceGroupQueries } from 'hooks/backend/audienceGroup';
import { AudienceGroup } from '../../../../types/domainModels';

import AddButton from 'components/common/forms/AddButton';

import { DemographicTarget } from './DemographicTarget';

export const DemographicTargets = (): JSX.Element => {
  const [audienceTargets] = useField<
    DemographicFormData['audienceProfile']['audienceTargets']
  >('audienceProfile.audienceTargets');
  const [selectedCountry] =
    useField<DemographicFormData['selectedCountry']>('selectedCountry');

  const { data: audienceGroupsResponse } = useQuery(
    audienceGroupQueries.list(),
  );
  const [audienceGroups, setAudienceGroups] = useState<AudienceGroup[]>([]);

  useEffect(() => {
    if (audienceGroupsResponse) {
      const filteredAudienceGroups = audienceGroupsResponse.filter(
        (group) =>
          group.countryCode === 'ALL' ||
          group.countryCode === selectedCountry.value,
      );
      setAudienceGroups(filteredAudienceGroups);
    }
  }, [audienceGroupsResponse, selectedCountry.value]);

  return (
    <FieldArray
      name="audienceProfile.audienceTargets"
      render={(arrayHelpers) => {
        return (
          <div>
            {audienceTargets.value.map((_target, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-col rounded-lg space-y-2 bg-gray-100 p-4 mb-6"
                >
                  <div className="text-xs font-medium text-gray-900 mb-2">
                    Audience Target {index + 1}
                  </div>
                  <DemographicTarget
                    audienceGroups={audienceGroups}
                    index={index}
                    onRemoveCategory={() => {
                      if (audienceTargets.value.length > 1) {
                        arrayHelpers.remove(index);
                      } else {
                        arrayHelpers.replace(index, getEmptyAudience());
                      }
                    }}
                  />
                </div>
              );
            })}

            <div className="flex">
              <AddButton
                label="Add Audience Target"
                onClick={() => {
                  arrayHelpers.push(getEmptyAudience());
                }}
              />
            </div>
          </div>
        );
      }}
    />
  );
};
